import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import { Button, Text } from '@belong/ui';
import { STRINGS } from 'accounts/constants/strings/reschedule-appointment';
import { useRescheduleAppointmentContext } from 'accounts/hooks/reschedule-appointment';

export function RescheduleAppointmentSuccessStep() {
  const { width } = useWindowSize();
  const {
    formattedAppointmentDate,
    onDismiss,
    isHandledByAnExternalProvider = false,
  } = useRescheduleAppointmentContext();

  const isMobile = width < BREAKPOINTS_WIDTHS.SM;

  return (
    <div className="w-full px-sm pt-3xl sm:pt-0">
      <div className="mb-sm text-center">
        <Text
          variant="h2"
          fontWeight="semibold"
          className="text-[36px] leading-[44px]"
        >
          {STRINGS['step.success.title']}
        </Text>
      </div>
      <div className="mb-2xl flex justify-center sm:mb-xl">
        <div className="max-w-[320px] text-center md:max-w-[420px]">
          <Text>
            {isHandledByAnExternalProvider
              ? `${STRINGS['step.success.description']} ${formattedAppointmentDate}`
              : STRINGS['step.success.description.external']}
          </Text>
        </div>
      </div>
      <div className="flex w-full justify-center sm:mb-2xl">
        <Button onClick={onDismiss} size={isMobile ? 'fluid' : 'large'}>
          <Text fontWeight="semibold">
            {STRINGS['step.success.confirmation']}
          </Text>
        </Button>
      </div>
    </div>
  );
}
